module.exports = __webpack_public_path__ + "static/media/td.5b27f2a1.png";